import React from 'react';
import { ChevronRightIcon, LeafIcon, PackageIcon, RecycleIcon, SparklesIcon, SproutIcon, Trash2Icon } from 'lucide-react';
import { categories, collectionsByDate, formatLongDate, toKey, type CategoryId } from '../../data/calendrierCollectes';
const icons: Record<CategoryId, typeof RecycleIcon> = {
  recyclage: RecycleIcon,
  dechets: Trash2Icon,
  organiques: LeafIcon,
  jardin: SproutIcon,
  lourds: PackageIcon,
  speciales: SparklesIcon
};
interface DayDetailsProps {
  date: Date;
}
export function DayDetails({
  date
}: DayDetailsProps) {
  const events = collectionsByDate[toKey(date)] ?? [];
  return <section aria-live="polite" aria-labelledby="day-title" data-id="element-675" data-mp="166rff9dfikg">
      <h2 id="day-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-676" data-mp="65t6lu8rf8vw">
        {formatLongDate(date)}
      </h2>

      {events.length === 0 ? <p className="mt-4 rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-6 text-sm text-slate-500" data-id="element-677" data-mp="2lzboh3z1otis">
          No collection scheduled at your address that day.
        </p> : <ul className="mt-4 space-y-3" data-id="element-678" data-mp="2osge8mzl7xa9">
          {events.map(id => {
        const category = categories[id];
        const Icon = icons[id];
        return <li key={id} data-id="element-679" data-mp="2xslaq238tb9n">
                <button type="button" className="flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-680" data-mp="2ss70qei2zr8z">
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl ${category.chip}`} aria-hidden="true" data-id="element-681" data-mp="3ggqakygs4c36">
                    <Icon className="h-5 w-5" data-id="element-682" data-mp="3cgzlcz6wi40r" />
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-683" data-mp="3qh0koa7ip3e4">
                    <span className="block font-bold uppercase tracking-wide text-ville-navy" data-id="element-684" data-mp="3lgw6wrxzumrl">{category.label}</span>
                    <span className="block text-sm text-slate-500" data-id="element-685" data-mp="2j3zypomv00y5">{category.time}</span>
                  </span>
                  <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-686" data-mp="2n4a532ekctdj" />
                </button>
              </li>;
      })}
        </ul>}
    </section>;
}